import EventProviderWC from '@ui5/webcomponents-base/dist/EventProvider';

export const EventProvider = new EventProviderWC();
